import { Component, inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { Menubar } from 'primeng/menubar';
import { TherapistStateService } from '@therapist/shared/services/state/therapist-state.service';
import { MenuItem } from 'primeng/api';
import { TherapistAuthStateService } from '@therapist/shared/services/state/therapist-auth-state.service';
import { filter } from 'rxjs';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { WithMobileDetection } from '@base/mixins/with-mobile-detection.mixin';

@Component({
  selector: 'sana-tp-sidebar',
  imports: [
    RouterLink
  ],
  templateUrl: './therapist-sidebar.component.html',
  styleUrl: './therapist-sidebar.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class TherapistSidebarComponent extends WithMobileDetection() {

  @ViewChild('menubar', { static: true }) menubar!: Menubar;

  readonly #therapistStateService = inject(TherapistStateService);
  readonly #authStateService = inject(TherapistAuthStateService);
  readonly #router = inject(Router);

  readonly currentTherapist = this.#therapistStateService.getCurrentTherapist();

  defaultItems: MenuItem[] = [
    { id: 'home', label: 'Home', routerLink: '/' }
  ];

  mobileItems: MenuItem[] = [
    { id: 'home', label: 'Home', icon: 'pi pi-home', routerLink: '/' },
    { id: 'logout', label: 'Logout', icon: 'pi pi-power-off', command: () => this.logout() }
  ];

  constructor() {
    super();

    this.#router
      .events
      .pipe(filter(evt => evt instanceof NavigationEnd))
      .subscribe(event => {
        // since it seems to be impossible to close the open submenu when navigating around, we simulate a click on the menu button to close it...
        (document.querySelectorAll('.p-menubar-button')?.item(0) as HTMLElement)?.click();
      });
  }

  logout(): void {
    this.#authStateService.logout();
  }
}
